import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tooltip from '../Tooltip';

const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

const QuestionMark = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: var(--color-primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  cursor: help;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--color-primary-dark);
  }
`;

function QuestionIcon({ className }) {
  return (
    <IconWrapper className={className}>
      <Tooltip>
        <QuestionMark>?</QuestionMark>
      </Tooltip>
    </IconWrapper>
  );
}

QuestionIcon.propTypes = {
  className: PropTypes.string,
};

QuestionIcon.defaultProps = {
  className: '',
};

export default QuestionIcon;
